<template>
  <div class="d-block py-0 black--text w-80 row justify-content-center">
    <div class="col-12 col-md-6">
      <table style="width: 500px; border: 2px solid black; border-collapse: collapse">
        <tbody>
          <tr>
            <td
              style="
                  border-top: 2px solid black;
                  border-left: 2px solid black;
                  border-bottom: 2px solid black;
                  padding: 0.5em;
                "
            >
              <img
                src="/assets/icons/logo-text-black.png"
                alt="logo-invoice"
                id="logo_invoice"
                style="height: 50px"
              />
            </td>
            <td
              style="
                  border-top: 2px solid black;
                  border-right: 2px solid black;
                  border-bottom: 2px solid black;
                  padding: 0.5em;
                  text-align: right;
                "
            >
              <span v-if="data && data.po_shipping_method =='courier'  ">
                <img
                  :src="'/assets/courier/' + data.po_courier_code + '.svg'"
                  alt="logo-kurir"
                  id="logo_invoice"
                  style="height: 40px"
                />
              </span>
            </td>
          </tr>
          <tr v-if="data.awb_kiriminaja">
            <td
              style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                "
              colspan="2"
            >
              <!-- <strong>NON-COD</strong> -->
              <barcode
                id="awb"
                style="display: block; width: 100%; height: 100px;"
                tag="img"
                :options="{ displayValue: false }"
                :value="data.awb_kiriminaja"
              ></barcode>
              <strong>AWB: {{ data.awb_kiriminaja }}</strong>
            </td>
          </tr>
          <tr v-else>
            <td
              style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                "
              colspan="2"
            >
              
              <strong style="color:red">
                SISTEM SEDANG MENUNGGU CALLBACK NOMOR RESI, MOHON UNTUK TIDAK DICETAK
                HINGGA MENDAPATKAN NOMOR RESI. 
              </strong>
            </td>
          </tr>
          <tr>
            <td
              style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                "
              colspan="2"
            >
              <!-- <strong>NON-COD</strong> -->
              <strong v-if="data.is_cod=='1'">COD: {{ data.po_price_shipping | toRupiah }}</strong>
              <strong v-else>NON-COD</strong>
            </td>
          </tr>
          <tr>
            <td
              style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                "
              colspan="2"
            >
              <strong>
                <span>
                  <div>
                    <div>
                      JENIS LAYANAN:
                      {{
                      data.po_courier_code
                      ? data.po_courier_code.toUpperCase()
                      : ""
                      }}
                      - {{ data.po_courier_service }}
                    </div>
                  </div>
                </span>
              </strong>
            </td>
          </tr>
          <tr>
            <td
              style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  width: 60%;
                "
              rowspan="3"
            >
              <center v-if="data.order_id_kiriminaja">
                <barcode
                  id="awb"
                  style="display: block; width: 100%; height: 100%"
                  tag="img"
                  :options="{ displayValue: false }"
                  :value="data.order_id_kiriminaja"
                ></barcode>
                <strong style="font-size: 10px">OID : {{ data.order_id_kiriminaja }}</strong>
              </center>
            </td>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>Asuransi: {{ data.po_price_insurance | toRupiah }}</strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                <span>
                  <div>
                    <div>Berat: {{ grandWeightTotal | toKg }}</div>
                  </div>
                </span>
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                <span>
                  <div>
                    <div>Quantity: {{ qty }}</div>
                  </div>
                </span>
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>
                Isi Paket :
                <br />
                <strong>{{isiPaket}}</strong>
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                Penerima :
                <br />
                <span>
                  <div class="text-caption pr-5">
                    <strong>{{ data.destination_name }}</strong>
                    <br />
                    {{ data.destination_phone }} | {{ data.destination_address }},
                    {{ data.user_address_subdistrict_name }},
                    {{ data.user_address_city_name }},
                    {{ data.user_address_province_name }},
                    {{ data.user_address_zipcode }}
                    <br />
                  </div>
                  <!-- <pre>{{rows.shipping_json.param.packages}}</pre> -->
                </span>
              </strong>
            </td>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                Pengirim :
                <br />
                {{ data.origin_name }},
                <br />
                {{ data.origin_phone }}
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>CATATAN: {{ data.po_courier_note }}</strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>
                PASTIKAN REKAM VIDEO KETIKA UNBOXING. KLAIM KERUSAKAN AKIBAT
                PENGIRIMAN TANPA VIDEO, TIDAK DAPAT DITINDAK LANJUTI
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: Object,
    isMobile: Boolean,
    grandWeightTotal: Number
  },
  computed: {
    // ...mapState("storeSeller", ["detailStore"]),
    isiPaket() {
      if (!this.data) return "";
      else {
        let dataItem = this.data.po_detail;
        let strIsi = "";
        dataItem.forEach((row, idx) => {
          if (idx == 0) {
            strIsi += row.po_detail_product_name;
          } else {
            strIsi += "," + row.po_detail_product_name;
          }
        });
        if (strIsi != "") {
          strIsi = strIsi.substr(0, 50);
        }
        return strIsi;
      }
    },
    products() {
      if (!this.data) return [];
      return this.data.po_detail;
    },
    qty() {
      if (this.products.length < 1) return 0;
      return this.products.reduce(
        (a, b) => a + Number(b.po_detail_quantity_requested),
        0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>